import jsZip from "jszip";
import { saveAs } from 'file-saver';

export const exportPost = (postData) => {

    // -----------------------------File Structure-----------------
    // - Title of post (folder)
    //     - url+_thumbnail.jpg (horizontal)
    //     - url.jpg (vertical)
    //     - blogpost.md
    //     - images(folder)
    //         - image1.jpg
    //         - image2.png
    //-------------------------------------------------------------

    let zip = new jsZip();

    // parent folder - same name as post title 
    let parentFolder = zip.folder(postData.title + ".zip");

    // blogPost.md file
    parentFolder.file(postData.date + '-' + postData.url + ".md", postData.head + '\n\n' + postData.content);

    // horizontal thumbnail
    if (postData.horizontalThumbnail) {
        let base64 = postData.horizontalThumbnail.dataUrl.substr(postData.horizontalThumbnail.dataUrl.indexOf(',') + 1);
        parentFolder.file(postData.url + "_thumbnail." + postData.horizontalThumbnail.name.split('.').pop(), base64, { base64: true });
    }

    // vertical thumbnail
    if (postData.verticalThumbnail) {
        let base64 = postData.verticalThumbnail.dataUrl.substr(postData.verticalThumbnail.dataUrl.indexOf(',') + 1);
        parentFolder.file(postData.url + '.' + postData.verticalThumbnail.name.split('.').pop(), base64, { base64: true });
    }

    // images folder
    let img = parentFolder.folder(postData.url);
    let imgBlocks = ['image', 'featuredProduct'];
    postData.jsonBlocks.blocks
        .filter(b => imgBlocks.includes(b.type))
        .forEach(block => {
            if (block.data.dataUrl) {
                let base64Img = block.data.dataUrl.substr(block.data.dataUrl.indexOf(',') + 1);
                img.file(block.data.name || block.data.imgName, base64Img, { base64: true });
            }
        })
    zip.generateAsync({ type: "blob" })
        .then(function (content) {
            // zip file - same name as post title 
            saveAs(content, postData.title + ".zip");
        });
}